import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './EconomicCalendar.css';

const EconomicCalendar = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const economicCalendarArticles = [
    {
      id: 1,
      category: 'FED DECISION',
      title: 'Federal Reserve Holds Rates Steady as Inflation Data Mixed',
      subtitle: 'Central bank maintains policy stance while keeping door open for future adjustments',
      date: 'January 27, 2026',
      time: '2 hours ago',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop',
      slug: 'fed-holds-rates-steady'
    },
    {
      id: 2,
      category: 'JOBS REPORT',
      title: 'US Unemployment Rate Falls to 3.4% as Employers Add 350K Jobs',
      subtitle: 'Labor market remains resilient despite higher interest rates',
      date: 'January 27, 2026',
      time: '4 hours ago',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=450&fit=crop',
      slug: 'unemployment-rate-falls'
    },
    {
      id: 3,
      category: 'GDP DATA',
      title: 'US Economy Grows 3.2% in Q4, Beating Expectations',
      subtitle: 'Consumer spending and business investment drive stronger-than-expected growth',
      date: 'January 26, 2026',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&h=450&fit=crop',
      slug: 'us-gdp-grows-q4'
    },
    {
      id: 4,
      category: 'INFLATION',
      title: 'Core CPI Rises 3.1% Year-Over-Year, Below Forecasts',
      subtitle: 'Cooling inflation data supports case for potential rate cuts later this year',
      date: 'January 26, 2026',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=800&h=450&fit=crop',
      slug: 'core-cpi-rises'
    }
  ];

  // Economic Calendar News List - Left Column
  const economicCalendarListLeft = [
    { id: 1, title: 'Fed Signals Two Rate Cuts Possible in 2026', time: '30 minutes ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'fed-signals-rate-cuts-2026' },
    { id: 2, title: 'Jobs Report Shows 285K New Positions Added', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=50&h=50&fit=crop', slug: 'jobs-report-285k-positions' },
    { id: 3, title: 'Core CPI Rises 0.3% in Latest Inflation Reading', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=50&h=50&fit=crop', slug: 'core-cpi-rises-inflation' },
    { id: 4, title: 'GDP Growth Revised Up to 3.2% for Q4 2025', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=50&h=50&fit=crop', slug: 'gdp-growth-revised-q4' },
    { id: 5, title: 'Retail Sales Jump 1.4% Beating Forecasts', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=50&h=50&fit=crop', slug: 'retail-sales-beat-forecasts' },
    { id: 11, title: 'Manufacturing PMI Hits 53.2 Indicating Expansion', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=50&h=50&fit=crop', slug: 'manufacturing-pmi-expansion' },
    { id: 12, title: 'Housing Starts Decline 6% as Rates Stay Elevated', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=50&h=50&fit=crop', slug: 'housing-starts-decline-rates' },
    { id: 13, title: 'Trade Deficit Narrows to $65B on Export Strength', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=50&h=50&fit=crop', slug: 'trade-deficit-narrows-exports' },
    { id: 14, title: 'Consumer Confidence Index Climbs to 115.8', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=50&h=50&fit=crop', slug: 'consumer-confidence-climbs' },
    { id: 15, title: 'Initial Jobless Claims Fall to 202K', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=50&h=50&fit=crop', slug: 'jobless-claims-fall-202k' }
  ];

  // Economic Calendar News List - Right Column
  const economicCalendarListRight = [
    { id: 6, title: 'ECB Holds Rates Steady at 3.5% Amid Growth Concerns', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=50&h=50&fit=crop', slug: 'ecb-holds-rates-steady' },
    { id: 7, title: 'Bank of Japan Raises Policy Rate to 0.75%', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=50&h=50&fit=crop', slug: 'boj-raises-policy-rate' },
    { id: 8, title: 'China GDP Growth Accelerates to 5.4% Year-over-Year', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=50&h=50&fit=crop', slug: 'china-gdp-accelerates' },
    { id: 9, title: 'UK Inflation Rate Drops to 2.8% in Latest Report', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=50&h=50&fit=crop', slug: 'uk-inflation-drops' },
    { id: 10, title: 'Eurozone Unemployment Holds at 6.4% Record Low', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=50&h=50&fit=crop', slug: 'eurozone-unemployment-record-low' },
    { id: 16, title: 'Canadian Employment Gains 42K Jobs in January', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=50&h=50&fit=crop', slug: 'canada-employment-42k-jobs' },
    { id: 17, title: 'Australian CPI Moderates to 3.2% Annual Rate', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=50&h=50&fit=crop', slug: 'australia-cpi-moderates' },
    { id: 18, title: 'German Factory Orders Surge 4.8% Month-over-Month', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=50&h=50&fit=crop', slug: 'german-factory-orders-surge' },
    { id: 19, title: 'RBNZ Signals End of Hiking Cycle at 5.5%', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'rbnz-end-hiking-cycle' },
    { id: 20, title: 'Brazil Central Bank Cuts Rates by 50 Basis Points', time: '10 hours ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'brazil-central-bank-cuts-rates' }
  ];

  return (
    <>
      <Helmet>
        <title>Economic Calendar & Data Releases - Fed, Jobs, GDP, Inflation | Redbox Global</title>
        <meta name="description" content="Track major economic data releases, central bank decisions, jobs reports, GDP data, and inflation metrics. Stay informed about key economic indicators and market-moving events." />
        <meta name="keywords" content="economic calendar, economic data, Fed decision, jobs report, unemployment, GDP, inflation, CPI, central bank, economic indicators, market events" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Economic Calendar & Data Releases - Redbox Global" />
        <meta property="og:description" content="Track major economic data releases, central bank decisions, jobs reports, and key market-moving events from Redbox Global." />
        <meta property="og:url" content="https://redboxglobal.com/markets/economic-calendar" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Economic Calendar & Data Releases - Redbox Global" />
        <meta name="twitter:description" content="Track major economic data releases, central bank decisions, jobs reports, and key market-moving events." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        <link rel="canonical" href="https://redboxglobal.com/markets/economic-calendar" />
      </Helmet>

      <div className="economic-calendar-page">
        <div className="container">
          {/* Breadcrumb */}
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <Link to="/markets">Markets</Link>
            <span className="separator">/</span>
            <span className="current">Economic Calendar</span>
          </nav>

          {/* Page Header */}
          <header className="page-header">
            <h1 className="page-title">Economic Calendar</h1>
            <p className="page-description">
              Your comprehensive guide to upcoming economic data releases, central bank decisions, and market-moving economic indicators from around the globe.
            </p>
          </header>

          {/* Featured Article */}
          <section className="featured-section">
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              loop
              className="economic-calendar-swiper"
            >
              {economicCalendarArticles.map((article) => (
                <SwiperSlide key={article.id}>
                  <article className="featured-article">
                    <Link to={`/article/${article.slug}`} className="featured-link">
                      <div className="featured-image">
                        <img src={article.image} alt={article.title} />
                        <span className="featured-category">{article.category}</span>
                      </div>
                    </Link>
                    <div className="featured-content">
                      <h2 className="featured-title">
                        <Link to={`/article/${article.slug}`}>{article.title}</Link>
                      </h2>
                      <p className="featured-subtitle">{article.subtitle}</p>
                      <div className="article-meta">
                        <span className="author">{article.author}</span>
                        <span className="date">{article.time}</span>
                        <span className="read-time">{article.readTime}</span>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>

          {/* Bloomberg-style Two Column List */}
          <section className="bloomberg-two-columns">
            <div className="bloomberg-column">
              {economicCalendarListLeft.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
            
            <div className="bloomberg-column">
              {economicCalendarListRight.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default EconomicCalendar;
